import React, { useState } from 'react'
import style from "./Faqs.module.css";
import data from "../../json/Homepage/Faqs.json";

const Faqs = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleAnswer = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const leftItems = data.questions.filter((_, i) => i % 2 === 0);
    const rightItems = data.questions.filter((_, i) => i % 2 !== 0);

    const renderItem = (item, originalIndex) => (
        <div key={originalIndex} className={style.qaItem}>
            <div className={style.questionRow}>
                <p className={style.faqquestion}>{item.question}</p>
                <button
                    aria-label={openIndex === originalIndex ? "Collapse answer" : "Expand answer"}
                    className={style.toggleBtn}
                    onClick={() => toggleAnswer(originalIndex)}
                >
                    {openIndex === originalIndex ? "−" : "+"}
                </button>
            </div>
            {openIndex === originalIndex && (
                <p className={style.faqanswer}>{item.answer}</p>
            )}
        </div>
    );

    return (
        <div className={style.faqscontainer}>
            <div className="container">
                <div className={style.faqstextcontainer}>
                    <p className={style.faqstopic}>{data.topic}</p>
                    <h1 className={style.faqfullform}>{data.fullform}</h1>
                </div>

                <div className={style.qaList}>
                    <div className={style.qaColumn}>
                        {leftItems.map((item, i) => renderItem(item, i * 2))}
                    </div>
                    <div className={style.qaColumn}>
                        {rightItems.map((item, i) => renderItem(item, i * 2 + 1))}
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Faqs;
